// extracted by mini-css-extract-plugin
export default {"messages":"MessagesList_messages__ZgqXO","messageContainerMy":"MessagesList_messageContainerMy__IF-Mw"};